import I18n from 'I18n';
import { RichTextFields } from 'ui-forms-components/constants/FieldTypeMapping';
import { defaultImage } from 'FormsCommonComponents/constants/RichTextImage';
import getStaticUrl from 'forms-utils-lib/urls/app/getStaticUrl';
export default ((fieldType = RichTextFields.HEADER) => {
  if (fieldType === RichTextFields.IMAGE) {
    return `<img src="${getStaticUrl()}/${defaultImage}" style="max-width: 100%; max-height: 100%">`;
  }
  return I18n.text(`editor.form.formFields.defaultValues.richText.${fieldType}`);
});